import { Component, OnInit, HostListener} from '@angular/core';
import { HomeService } from 'src/app/home/services/home.service';
import { StatePersistService } from 'src/app/core/services/state-persist.service';
import { ActivatedRoute, Router } from '@angular/router';
import { SharedConsts } from '../../constants';
import { SharedService } from '../../services/shared.service';
import { Apollo, QueryRef } from 'apollo-angular';
import gql from 'graphql-tag';
import { GoogleAnalyticsService } from '../../services/google-analytics.service';
import { Subscription } from 'rxjs';
import {  Store } from '@ngrx/store';
import { SharedState } from '../../store/reducers';
import { brandListing } from '../../store/actions/shared.actions';


@Component({
    selector: 'category-component',
    templateUrl: './category-component.component.html',
    styleUrls: ['./category-component.component.scss'],
    standalone: false
})
export class CategoryComponentComponent implements OnInit {
  [x: string]: any;
  selectedStore: any={};
  socialMediaDetail: any;
  oneAtATime = true;
  SOCIAL_MEDIA_QUERY = gql`
  query  {
    socialMediasWOS{
        id
        stage
        url
        image1{
            id
            fileName
            url
        }
        image2{
            id
            fileName
            url
        }
    }
}
`;
  private query: QueryRef<any>;
  constantsValues = SharedConsts;


  brandsListSubscriber$!:Subscription;
mobileMain: boolean = false; 
  brandsListByCategory:Array<any>=[];
  selectedBrand:Array<any>=[];
  bannerBrands:Array<any>=[];

  constructor(
    private homeService: HomeService, 
    public statePersist: StatePersistService,
    private activatedRoute: ActivatedRoute, 
    private router: Router,
    private sharedService: SharedService, 
    private apollo: Apollo, 
    private sharedState:Store<SharedState>,
    private googleAnalyticsService: GoogleAnalyticsService) { }
  isNewButtonDisable=false
  selectedItem = ''
  seasonal = '0'
  new = '0'
  noRecord = false;
  categoryMessage = '';
  classToggled = false;
  categories = [];
  topCategories = [];
  topCategoriesDefaultImage=''
  topCategoriesDefaultImageTemp=''
  nextPage = 1;
  topMenueCalled = false;
  ngOnInit(): void {
    this.onInitHelper();
    this.getBrandsList();
   }




   onInitHelper():void{
    this.selectedStore = this.statePersist.getLocalStorage('selectedStoreAddress');

    this.query = this.apollo.watchQuery({
      query: this.SOCIAL_MEDIA_QUERY,
      variables: {}
    });

    this.query.valueChanges.subscribe(result => {
   
      this.socialMediaDetail = result.data
    
    });

    this.statePersist.watchcategoryDetailStorage().subscribe(message => {
      if (!this.topMenueCalled){
        this.refreshData()
      }
    }) ;

    this.selectedItem = 'All'

    if (!this.topMenueCalled){
      this.getTopMenu('')
    }
    
    let routeParams;
    this.categoryId = ''
    this.seasonal = '0'
    this.new = '0'
    this.statePersist.watchCategoryStorage().subscribe(message => {
      this.category_data = this.statePersist.getLocalStorage('selected_category')
      if (this.category_data != '' && this.category_data != undefined && this.category_data != null){
        this.categoryId = parseInt(this.category_data)
        this.selectedItem = String(this.categoryId)
      }
      else{
        this.categoryId = ''
        this.selectedItem = ''
      }
    })
    routeParams = this.activatedRoute.snapshot.paramMap.get('categoryid');
    
    this.showAsPerSelection(routeParams);

    this.statePersist.watchGlobalDataStorage().subscribe(message => {
      this.global_data = this.statePersist.getLocalStorage('global_data')
      let global_data = this.statePersist.getLocalStorage('global_data')
      if(global_data['new_product_count'].toString()=='0'){
        this.isNewButtonDisable=true
      }
    })

    if (this.statePersist.getLocalStorage('global_data') != null){
      let global_data = this.statePersist.getLocalStorage('global_data')
      if(global_data['new_product_count'].toString()=='0'){
        this.isNewButtonDisable=true
      }
    }
   }

   showAsPerSelection(routeParams:string):void{
    if (routeParams && routeParams.includes('-') && this.isNumeric(routeParams.split('-')[0])) {
      this.categoryId = parseInt(routeParams.split('-')[0])
      this.selectedItem = String(this.categoryId)
    }
    else if (this.router.url.includes('product/listing/All')){
      this.selectedItem = 'All'
      this.categoryId = ''
      this.seasonal = '0'
      this.new = '0'
    }
    else if (this.router.url.includes('product/listing/Seasonal')){
      this.selectedItem = 'Seasonal'
      this.categoryId = ''
      this.seasonal = '1'
      this.new = '0'
    }
    else if (this.router.url.includes('product/listing/New')){
      this.selectedItem = 'New'
      this.categoryId = ''
      this.seasonal = '0'
      this.new = '1'
    }
    else{
      this.selectedItem = ''
      this.categoryId = ''
    }
   }
  
  refreshData(){
  this.noRecord = false;
  this.classToggled = false;
  this.categories = [];
  this.topCategories = [];
  this.nextPage = 1;
  this.selectedItem = 'All'
  this.getTopMenu('refresh')
  this.categoryId = ''
  this.seasonal = '0'
  this.new = '0'
  this.selectedStore = this.statePersist.getLocalStorage('selectedStoreAddress')
  }

  routerSet(){
    var routeParams;
    
    if(this.activatedRoute.snapshot.paramMap.get('categoryid') == this.router.url.split('/')[this.router.url.split('/').length-1]){
      routeParams = this.activatedRoute.snapshot.paramMap.get('categoryid')
      if (routeParams && routeParams.includes('-') && this.isNumeric(routeParams.split('-')[0])) {
        this.categoryId = parseInt(routeParams.split('-')[0])
        this.selectedItem = String(this.categoryId)
        var obj;
        obj = false;
        for (let i = 0; i < this.topCategories.length; i++) {
          if(this.topCategories[i].hasOwnProperty("sub_cat") && this.topCategories[i]['sub_cat'].length > 0){
            for (let j = 0; j < this.topCategories[i]['sub_cat'].length; j++){
              if(parseInt(this.topCategories[i]['sub_cat'][j].id) == this.categoryId){
                obj = true
              }
  
            }
          }
          else{
            if(parseInt(this.topCategories[i].id) == this.categoryId){
              obj = true
            }
          }
        }
        if (!obj){
          this.statePersist.setLocalStorage('product_data', {'brand_filter':''});
          this.router.navigate(['/product/listing/All']);
        }
      }
      else if (this.router.url.includes('product/listing/All')){
        this.selectedItem = 'All'
        this.categoryId = ''
        this.seasonal = '0'
        this.new = '0'
      }
      else if (this.router.url.includes('product/listing/Seasonal')){
        this.selectedItem = 'Seasonal'
        this.categoryId = ''
        this.seasonal = '1'
        this.new = '0'
      }
      else if (this.router.url.includes('product/listing/New')){
        this.selectedItem = 'New'
        this.categoryId = ''
        this.seasonal = '0'
        this.new = '1'
        // this.seasonal = '1'
      }
      else{
        this.selectedItem = ''
        this.categoryId = ''
      }
    }
    
  }

  public toggleField() {
    this.classToggled = !this.classToggled;
  }
  isNumeric(value) {
    return this.constantsValues.NUMBER_PATTERN.test(value);
  }

  selectEventApply(value){
    if (value == 'All'){
      this.googleAnalyticsService.eventEmitter(SharedConsts.HOME_ALL_MENU_SELECTED_EVENT, SharedConsts.GOOGLEANALYTICSS_EVENT_CATEGORY_NAME, SharedConsts.HOME_ALL_MENU_SELECTED_EVENT_ACTION, SharedConsts.GOOGLEANALYTICSS_EVENT_LABEL, SharedConsts.GOOGLEANALYTICSS_EVENT_VALUE);
    }
    else if (value == 'My Orders'){
      this.googleAnalyticsService.eventEmitter(SharedConsts.HOME_MYORDER_MENU_SELECTED_EVENT, SharedConsts.GOOGLEANALYTICSS_EVENT_CATEGORY_NAME, SharedConsts.HOME_MYORDER_MENU_SELECTED_EVENT_ACTION, SharedConsts.GOOGLEANALYTICSS_EVENT_LABEL, SharedConsts.GOOGLEANALYTICSS_EVENT_VALUE)
    }
    else{
      this.googleAnalyticsService.eventEmitter(SharedConsts.HOME_CATEGORY_MENU_SELECTED_EVENT, SharedConsts.GOOGLEANALYTICSS_EVENT_CATEGORY_NAME, SharedConsts.HOME_CATEGORY_MENU_SELECTED_EVENT_ACTION, SharedConsts.GOOGLEANALYTICSS_EVENT_LABEL, SharedConsts.GOOGLEANALYTICSS_EVENT_VALUE)
    }

  }

  listClick(event, newValue, link, category) {
    this.selectedItem = newValue;  
    
    let product_data
    if (this.statePersist.getLocalStorage('product_data') != null){
      product_data = this.statePersist.getLocalStorage('product_data')
      if (product_data['search_keyword'] !== ''){
          product_data['search_keyword'] = ''
          this.statePersist.setLocalStorage('product_data',product_data, 'search')
      }
    }
    if (category != ''){
      this.categoryMessage = ''
      if (category.min_allowed_qty != null && category.min_allowed_qty != undefined){
        this.categoryMessage += 'Min Cases: '+category.min_allowed_qty+'|'
      }
      if(category.max_allowed_qty != null && category.max_allowed_qty != undefined){
        this.categoryMessage += 'Max Cases: '+category.max_allowed_qty+'|'
      }
      this.categoryMessageSend()
    }
    this.selectEventApply(this.selectedItem);
    this.statePersist.setLocalStorage('product_data', {'brand_filter':''}); 
    this.router.navigate([link])
    window.scroll({ 
      top: 0, 
      left: 0, 
      behavior: 'smooth' 
    });
}

mouseEnter(e){
  if(e.menu_title_image!='')
  {
    this.topCategoriesDefaultImage=e.menu_title_image
  }
  else{
    this.topCategoriesDefaultImage=this.topCategoriesDefaultImageTemp
  }
}

mouseLeave(e){
  this.topCategoriesDefaultImage=this.topCategoriesDefaultImageTemp
}

allPromotions(){
  this.googleAnalyticsService.eventEmitter(SharedConsts.HOME_PROMOTIONS_VIEW_ALL_EVENT, SharedConsts.GOOGLEANALYTICSS_EVENT_CATEGORY_NAME,SharedConsts.HOME_PROMOTIONS_VIEW_ALL_EVENT_ACTION , SharedConsts.GOOGLEANALYTICSS_EVENT_LABEL, SharedConsts.GOOGLEANALYTICSS_EVENT_VALUE);
  this.router.navigate(['promotion/All'])
}


scrollToNew() {
  if (document.getElementById('newDivScrollTarget'))
  {
    document.getElementById('newDivScrollTarget').scrollIntoView({behavior: 'smooth'});
    this.googleAnalyticsService.eventEmitter(SharedConsts.HOME_NEW_MENU_SELECTED_EVENT, SharedConsts.GOOGLEANALYTICSS_EVENT_CATEGORY_NAME, SharedConsts.HOME_NEW_MENU_SELECTED_EVENT_ACTION, SharedConsts.GOOGLEANALYTICSS_EVENT_LABEL, SharedConsts.GOOGLEANALYTICSS_EVENT_VALUE);
  }
  else{
    this.statePersist.setLocalStorage('scrollToHomepageElement', 'promotionsDivScrollTarget')
    this.googleAnalyticsService.eventEmitter(SharedConsts.HOME_NEW_MENU_SELECTED_EVENT, SharedConsts.GOOGLEANALYTICSS_EVENT_CATEGORY_NAME, SharedConsts.HOME_NEW_MENU_SELECTED_EVENT_ACTION, SharedConsts.GOOGLEANALYTICSS_EVENT_LABEL, SharedConsts.GOOGLEANALYTICSS_EVENT_VALUE);
    this.router.navigate(['/home'])

  }
}


scrollToPromotions() {
  if (document.getElementById('promotionsDivScrollTarget'))
  {
    document.getElementById('promotionsDivScrollTarget').scrollIntoView({behavior: 'smooth'});
    this.googleAnalyticsService.eventEmitter(SharedConsts.HOME_PROMOTION_MENU_SELECTED_EVENT, SharedConsts.GOOGLEANALYTICSS_EVENT_CATEGORY_NAME, SharedConsts.HOME_PROMOTION_MENU_SELECTED_EVENT_ACTION, SharedConsts.GOOGLEANALYTICSS_EVENT_LABEL, SharedConsts.GOOGLEANALYTICSS_EVENT_VALUE);
  }
  else{
    
    this.statePersist.setLocalStorage('scrollToHomepageElement', 'promotionsDivScrollTarget')
    this.googleAnalyticsService.eventEmitter(SharedConsts.HOME_PROMOTION_MENU_SELECTED_EVENT, SharedConsts.GOOGLEANALYTICSS_EVENT_CATEGORY_NAME, SharedConsts.HOME_PROMOTION_MENU_SELECTED_EVENT_ACTION, SharedConsts.GOOGLEANALYTICSS_EVENT_LABEL, SharedConsts.GOOGLEANALYTICSS_EVENT_VALUE);
    this.router.navigate(['/home'])
  }
}

scrollToBrands() {
  if (document.getElementById('brandsDivScrollTarget'))
  {
    document.getElementById('brandsDivScrollTarget').scrollIntoView({behavior: 'smooth'});
    this.googleAnalyticsService.eventEmitter(SharedConsts.HOME_BRAND_MENU_SELECTED_EVENT, SharedConsts.GOOGLEANALYTICSS_EVENT_CATEGORY_NAME, SharedConsts.HOME_BRAND_MENU_SELECTED_EVENT_ACTION, SharedConsts.GOOGLEANALYTICSS_EVENT_LABEL, SharedConsts.GOOGLEANALYTICSS_EVENT_VALUE);
  }
  else{
    this.statePersist.setLocalStorage('scrollToHomepageElement', 'brandsDivScrollTarget')
    this.googleAnalyticsService.eventEmitter(SharedConsts.HOME_BRAND_MENU_SELECTED_EVENT, SharedConsts.GOOGLEANALYTICSS_EVENT_CATEGORY_NAME, SharedConsts.HOME_BRAND_MENU_SELECTED_EVENT_ACTION, SharedConsts.GOOGLEANALYTICSS_EVENT_LABEL, SharedConsts.GOOGLEANALYTICSS_EVENT_VALUE);
    this.router.navigate(['/home'])
  }
}

redirectToAllProductMyRangeFilter(event){
  let url;
  this.statePersist.setLocalStorage('product_data', {'range':'1'})
  url = 'product/listing/All'
  if(this.router.url=='/product/listing/All'){
 
    this.router.navigateByUrl('/', {skipLocationChange: true}).then(() => {
      this.statePersist.setLocalStorage('product_data', {'brand_filter':''});
      this.router.navigate(['/product/listing/All']);
  });
  }
  else{
 
    this.router.navigate([url]);
  }
}

redirectToAllProductTopSellers(event){
  let url;
  this.statePersist.setLocalStorage('product_data', {'top_seller':'1'})
  url = 'product/listing/All'
  if(this.router.url=='/product/listing/All'){
  
    this.router.navigateByUrl('/', {skipLocationChange: true}).then(() => {
          this.statePersist.setLocalStorage('product_data', {'brand_filter':''});
      this.router.navigate(['/product/listing/All']);
  });
  }
  else{
  
    this.router.navigate([url]);
  }
}



  currentScrollPos = null;
  prevScrollpos = window.pageYOffset;
  @HostListener('window:scroll', [])
  onWindowScroll() {
    this.currentScrollPos = window.pageYOffset;
    if (this.prevScrollpos > this.currentScrollPos) {
      document.body.classList.remove('fixed');
    } else {
      document.body.classList.add('fixed');
    }
    this.prevScrollpos = this.currentScrollPos;
  }


  getCatgoryListing() {
    this.homeService.getCtagories()
    .subscribe(
      data => {
        if (data.response) {
          this.categories = data.response.top_categories
        }
      }
    );
  }

  categoryMessageUpdate(data, i){
    if (data[i].min_allowed_qty != null && data[i].min_allowed_qty != undefined){
      this.categoryMessage += data[i].name+' Min Cases: '+data[i].min_allowed_qty+'|'
    }
    if(data[i].max_allowed_qty != null && data[i].max_allowed_qty != undefined){
      this.categoryMessage += data[i].name+' Max Cases: '+data[i].max_allowed_qty+'|'
    }
  }

  categoryMessageSend(){
    var lastchar = this.categoryMessage.slice(-1)
    if (lastchar == '|'){
      this.categoryMessage = this.categoryMessage.slice(0, -1); 
    }
    this.statePersist.emitCategoryMessage(this.categoryMessage)
  }

  getTopMenu(refresh?:string){
    this.sharedService.topMenu()
    .subscribe(
      data => {
        if (data.response) {
          this.topMenueCalled = true;
          this.topCategories = data.response.menu_categories
          this.topCategoriesDefaultImage = data.response.menu_categories_image
          this.topCategoriesDefaultImageTemp = data.response.menu_categories_image
          if(this.router.url=='/product/listing/All'){
            for (let i = 0; i < this.topCategories.length; i++) {
              if (this.topCategories[i].sub_cat.length > 0){
                var subcat = this.topCategories[i].sub_cat
                for (let j = 0; j < subcat.length; j++){
                  this.categoryMessageUpdate(subcat, j)
                }
              }
              else{
                this.categoryMessageUpdate(this.topCategories, i)
              
              }
            }
            this.categoryMessageSend()
          }
          
          if(refresh !== ''){
       
            this.routerSet()
          }
        }
      }
    );
  }




  //=============== brands ==================================

  getBrandsList():void{

    this.brandsListSubscriber$ = this.homeService.getBrandsList().subscribe({
      next:(response:any)=>{

        //---------create a state for store
        const brandStoreData = {
          topBrands : [],
          brandByCategory :[],
          brandsList:[],
          bannerBrands:[]
        };
        
        if(response.length){

          brandStoreData.brandsList = [...response];


          const getBrands = this.homeService.getBrandsByCategory([...response]);
 
          if(getBrands &&  getBrands?.brandsList.length){

            const categoryByBrand = this.homeService.groupBrandsByAlphabet([...getBrands?.brandsList,...getBrands?.topBrands]);

            if(categoryByBrand){
              brandStoreData.brandByCategory = [...categoryByBrand];
              this.brandsListByCategory = [...categoryByBrand];
              this.selectedBrand = [...this.brandsListByCategory[0].brands]
            }     
          };

          const top_brands_arrr = JSON.parse(JSON.stringify(response));

          const findBrandWithBanner = (top_brands_arrr || []).filter(e=>e.image_url && e.top_brand);

          if(findBrandWithBanner.length){
            this.bannerBrands = [...findBrandWithBanner];
          }

          brandStoreData.bannerBrands = [...findBrandWithBanner];


          if(getBrands && getBrands?.topBrands.length){
            brandStoreData.topBrands = [...getBrands?.topBrands]
          }

          let brandState :any = {...brandStoreData};

          this.sharedState.dispatch(brandListing({header_brands_list:brandState}));
        }
        
      },error:(error:any)=>{
        console.log(error)
      }
    })
  }


  onBrandCatSelect(selectedBrands:Array<any>):void{
    this.selectedBrand = [...selectedBrands];
  }

  //--------------------reset brand categories on hover--------------------
  onDropdownHover(status:boolean):void{
    status && (this.selectedBrand = [...this.brandsListByCategory[0].brands]);
  }


  onBrandSelect(brandId:number):void{
    const parentRoute = this.activatedRoute.parent;
    let productData = JSON.parse(JSON.stringify(this.statePersist.getLocalStorage('product_data')));
    productData = {...productData,brand_filter:brandId.toString()};

    this.statePersist.setLocalStorage('product_data', productData);
    if(parentRoute && this.activatedRoute.parent.url['_value'].length && this.activatedRoute.parent.url['_value'][0].path == 'product'){
      this.sharedService.redirectAsBrandSelected(brandId,true,this.activatedRoute);
    }else{
      this.sharedService.redirectAsBrandSelected(brandId,false,{});
    }
  
    
  }

  ngOnDestroy(){
    this.brandsListSubscriber$?.unsubscribe();
  }

  toggleOpen(){
   this.mobileMain =  !this.mobileMain;
  }
  

}
